import { ShieldCheck, Lock } from "lucide-react";
import { HIPAA_PRACTICES } from "../data/content";
import { useLang } from "../i18n/LanguageContext";
import { Reveal } from "../components/Reveal";
import { BrandText } from "../components/Brand";
import PageHeader from "../components/PageHeader";
import CTASection from "../components/CTASection";

export default function Hipaa() {
  const { lang, t } = useLang();
  const p = t.pages.hipaa;

  return (
    <div data-testid="hipaa-page">
      <PageHeader
        overline={p.overline}
        title={p.titleA}
        accent={p.accent}
        subtitle={p.subtitle}
      />

      <section className="py-12 bg-navy">
        <div className="max-w-4xl mx-auto px-6 sm:px-8 text-center">
          <Reveal>
            <Lock size={44} className="text-gold mx-auto mb-6" />
            <p className="text-muted2 leading-relaxed text-lg"><BrandText>{p.intro}</BrandText></p>
          </Reveal>
        </div>
      </section>

      <section className="pb-20 bg-navy">
        <div className="max-w-6xl mx-auto px-6 sm:px-8 lg:px-12 grid grid-cols-1 md:grid-cols-2 gap-6">
          {HIPAA_PRACTICES.map((practice, i) => {
            const Icon = practice.icon;
            return (
              <Reveal key={practice.title.en} delay={0.06 * i}>
                <div
                  data-testid={`hipaa-practice-${i}`}
                  className="h-full bg-deepblack border border-gold/20 p-8 hover:border-gold/50 transition-colors duration-300"
                >
                  <div className="h-12 w-12 flex items-center justify-center border border-gold/30 text-gold mb-5">
                    <Icon size={22} />
                  </div>
                  <h3 className="font-serif text-2xl text-offwhite mb-3">{practice.title[lang]}</h3>
                  <p className="text-sm text-muted2 leading-relaxed">{practice.desc[lang]}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      <section className="py-16 bg-deepblack">
        <div className="max-w-4xl mx-auto px-6 sm:px-8 text-center">
          <Reveal>
            <ShieldCheck size={42} className="text-gold mx-auto mb-6" />
            <h2 className="font-serif text-3xl sm:text-4xl font-bold mb-5">{p.bottomTitle}</h2>
            <p className="text-muted2 leading-relaxed max-w-2xl mx-auto"><BrandText>{p.bottomBody}</BrandText></p>
          </Reveal>
        </div>
      </section>

      <CTASection />
    </div>
  );
}
